import React, { useRef, useEffect } from "react";
import ChatHeader from "./ChatHeader";
import ChatMessages from "./ChatMessages";
import ChatInput from "./ChatInput";

/**
 * ChatInterface Component
 * Complete chat interface combining header, messages, and input
 * This is the shared UI logic used by both embedded and floating modes
 */
const ChatInterface = ({
  messages,
  isTyping,
  isLoading,
  isAvailable,
  inputValue,
  onInputChange,
  onSendMessage,
  onKeyPress,
  onSuggestionClick,
  onClose,
  showCloseButton = false,
  isMobile = false,
  isSmallMobile = false,
  placeholder,
}) => {
  const inputRef = useRef(null);
  const messagesRef = useRef(null);

  // Focus input when component mounts or becomes visible
  useEffect(() => {
    if (inputRef.current) {
      inputRef.current.focus();
    }
  }, []);

  return (
    <>
      <ChatHeader
        isLoading={isLoading}
        isAvailable={isAvailable}
        onClose={onClose}
        showCloseButton={showCloseButton}
      />

      <ChatMessages
        ref={messagesRef}
        messages={messages}
        isTyping={isTyping}
        onSuggestionClick={onSuggestionClick}
        isSmallMobile={isSmallMobile}
      />

      <ChatInput
        inputRef={inputRef}
        value={inputValue}
        onChange={onInputChange}
        onSend={onSendMessage}
        onKeyPress={onKeyPress}
        placeholder={placeholder}
        isTyping={isTyping}
        isAvailable={isAvailable}
        isMobile={isMobile}
      />
    </>
  );
};

export default ChatInterface;
